<ion-item class="{{color}}-input"
          [class.item-has-value]="value !== '' && value !== null">

  <ion-label [color]="color" [position]="labelPosition">
    {{ label }}
    <span *ngIf="controlName && isRequired(controlName)" class="required">*</span>
  </ion-label>

  <div class="input-wrapper">

    <!-- Mode reactive forms -->
    <ng-container *ngIf="controlName">
      <ion-input 
        class="{{color}}-input"
        [color]="color"
        [formControl]="formGroup.get(controlName)"
        [type]="computedType"
        [placeholder]="placeholder"
        >
      </ion-input>
    </ng-container>

    <!-- Mode standalone -->
    <ng-container *ngIf="!controlName">
      <ion-input
        class="{{color}}-input"
        [color]="color"
        [type]="computedType"
        [value]="value"
        [placeholder]="placeholder"
        (ionInput)="handleIonInput($event)"
        (ionBlur)="handleBlur()">
      </ion-input>
    </ng-container>

    <!-- 👁️ toggle mot de passe -->
    <ion-icon
      *ngIf="type === 'password'"
      class="password-toggle"
      [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"
      (click)="togglePassword()">
    </ion-icon>

  </div>

</ion-item>
